export class BaseView {
  ItemCount?: number;
  UnfilteredItemCount?: number;
  PreviousPageSkip?: number | undefined; // for lists that require scroll back (e.g. conversations)
  NextPageSkip?: number | undefined;
  Cursor?: string;
  IsMyTypeFiltered?: boolean | null;
  NonPremiumLimitReached?: boolean;
}
